// Yofis — контракт API `yofis.v1`. Сообщения: текст, вложения, геолокация, опросы, реакции, поиск.
//
// Порядок сообщений в чате — по Snowflake домашнего сервера чата (ADR-024): идентификатор —
// десятичная строка, клиент парсит число только для локальной сортировки.
// Идемпотентность отправки — `client_msg_id` (UUIDv7, генерирует клиент).

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/message.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { EncryptionMode, PageInfo } from "./common_pb.ts";
import { file_yofis_v1_common } from "./common_pb.ts";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/message.proto.
 */
export const file_yofis_v1_message: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_yofis_v1_common]);

/**
 * Сообщение в чате.
 *
 * @generated from message yofis.v1.Message
 */
export type Message = Message$1<"yofis.v1.Message"> & {
  /**
   * Идентификатор — Snowflake домашнего сервера чата, десятичная строка.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Идентификатор чата `<snowflake>@<home_domain>`.
   *
   * @generated from field: string chat_id = 2;
   */
  chatId: string;

  /**
   * Адрес отправителя.
   *
   * @generated from field: string sender_address = 3;
   */
  senderAddress: string;

  /**
   * Клиентский идентификатор для идемпотентности (UUIDv7); возвращается только отправителю.
   *
   * @generated from field: string client_msg_id = 4;
   */
  clientMsgId: string;

  /**
   * Вид сообщения.
   *
   * @generated from field: yofis.v1.MessageKind kind = 5;
   */
  kind: MessageKind;

  /**
   * Текст (подпись к медиа/файлам); пусто у удалённых.
   *
   * @generated from field: string text = 6;
   */
  text: string;

  /**
   * Форматирование текста: смещения и длины в кодовых единицах UTF-16.
   *
   * @generated from field: repeated yofis.v1.TextEntity entities = 7;
   */
  entities: TextEntity[];

  /**
   * Вложения (MEDIA, FILE, голосовые, кружочки).
   *
   * @generated from field: repeated yofis.v1.Attachment attachments = 8;
   */
  attachments: Attachment[];

  /**
   * Идентификатор сообщения, на которое это ответ; пусто — не ответ.
   *
   * @generated from field: string reply_to_id = 9;
   */
  replyToId: string;

  /**
   * Откуда переслано; пусто — не пересылка.
   *
   * @generated from field: yofis.v1.ForwardInfo forward = 10;
   */
  forward?: ForwardInfo | undefined;

  /**
   * Реакции, сгруппированные по эмодзи.
   *
   * @generated from field: repeated yofis.v1.Reaction reactions = 11;
   */
  reactions: Reaction[];

  /**
   * Когда отправлено (время домашнего сервера чата).
   *
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Когда отредактировано; пусто — не редактировалось.
   *
   * @generated from field: google.protobuf.Timestamp edited_at = 13;
   */
  editedAt?: Timestamp | undefined;

  /**
   * «Сообщение удалено»: тело пустое, остаётся заглушка в истории.
   *
   * @generated from field: bool deleted = 14;
   */
  deleted: boolean;

  /**
   * Системное событие; заполнено при `kind == SYSTEM`.
   *
   * @generated from field: yofis.v1.SystemEvent system = 15;
   */
  system?: SystemEvent | undefined;

  /**
   * Режим шифрования; в v1 — SERVER.
   *
   * @generated from field: yofis.v1.EncryptionMode encryption_mode = 16;
   */
  encryptionMode: EncryptionMode;

  /**
   * Шифртекст клиентского шифрования; только при `encryption_mode == CLIENT` (закладка, ADR-019).
   *
   * @generated from field: bytes client_ciphertext = 17;
   */
  clientCiphertext: Uint8Array;

  /**
   * Версия ключа чата в серверном режиме; клиенту информативно (ротация при смене состава).
   *
   * @generated from field: int32 key_version = 18;
   */
  keyVersion: number;

  /**
   * Закреплено в чате.
   *
   * @generated from field: bool pinned = 19;
   */
  pinned: boolean;

  /**
   * Геолокация; заполнена при `kind == LOCATION`.
   *
   * @generated from field: yofis.v1.Location location = 20;
   */
  location?: Location | undefined;

  /**
   * Опрос; заполнен при `kind == POLL`.
   *
   * @generated from field: yofis.v1.Poll poll = 21;
   */
  poll?: Poll | undefined;

  /**
   * 0.14: содержимое не расшифровалось — тело пустое **не потому, что его нет**. Клиент обязан
   * показать это словами («сообщение не читается»), а не как пустое сообщение. Причину (пропавшая
   * версия ключа или негодный шифртекст) знает только узел: она в логе и в самопроверке, на проводе
   * её нет — человеку она ничего не даёт, а администратору нужна с подробностями.
   *
   * @generated from field: bool unreadable = 22;
   */
  unreadable: boolean;
};

/**
 * Describes the message yofis.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 0);

/**
 * Геолокация: разовая точка или live-трансляция.
 *
 * @generated from message yofis.v1.Location
 */
export type Location = Message$1<"yofis.v1.Location"> & {
  /**
   * Широта в градусах.
   *
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * Долгота в градусах.
   *
   * @generated from field: double lon = 2;
   */
  lon: number;

  /**
   * Точность в метрах (радиус).
   *
   * @generated from field: float accuracy_m = 3;
   */
  accuracyM: number;

  /**
   * Название места («Офис на Тверской»); опционально.
   *
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * Адрес места; опционально.
   *
   * @generated from field: string address = 5;
   */
  address: string;

  /**
   * Live-геолокация: пока не истекло, отправитель шлёт `UpdateLiveLocation`; пусто — разовая точка.
   *
   * @generated from field: google.protobuf.Timestamp live_until = 6;
   */
  liveUntil?: Timestamp | undefined;

  /**
   * Когда координаты обновлялись последний раз.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message yofis.v1.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 1);

/**
 * Опрос.
 *
 * @generated from message yofis.v1.Poll
 */
export type Poll = Message$1<"yofis.v1.Poll"> & {
  /**
   * Вопрос.
   *
   * @generated from field: string question = 1;
   */
  question: string;

  /**
   * Варианты ответа, от 2 до лимита узла.
   *
   * @generated from field: repeated yofis.v1.PollOption options = 2;
   */
  options: PollOption[];

  /**
   * Можно выбрать несколько вариантов.
   *
   * @generated from field: bool multiple_choice = 3;
   */
  multipleChoice: boolean;

  /**
   * Анонимный (0.7, ADR-030): сервер не хранит адреса голосовавших — только псевдоним, вычисляемый
   * с мастер-ключом узла (`HKDF(KEK, "poll-anon" ‖ message_id)`), поэтому дамп базы голоса не раскрывает.
   * Честная формулировка для интерфейса: администратор узла, имеющий доступ к мастер-ключу, технически
   * может сопоставить голоса с людьми — полной анонимности на сервере своей компании не бывает.
   *
   * @generated from field: bool anonymous = 4;
   */
  anonymous: boolean;

  /**
   * Когда закрывается автоматически; пусто — бессрочно (до `ClosePoll`).
   *
   * @generated from field: google.protobuf.Timestamp closes_at = 5;
   */
  closesAt?: Timestamp | undefined;

  /**
   * Закрыт (по времени или досрочно).
   *
   * @generated from field: bool closed = 6;
   */
  closed: boolean;

  /**
   * Сколько человек проголосовало.
   *
   * @generated from field: int32 total_voters = 7;
   */
  totalVoters: number;

  /**
   * Индексы вариантов, выбранных мной.
   *
   * @generated from field: repeated int32 my_votes = 8;
   */
  myVotes: number[];
};

/**
 * Describes the message yofis.v1.Poll.
 * Use `create(PollSchema)` to create a new message.
 */
export const PollSchema: GenMessage<Poll> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 2);

/**
 * Вариант ответа в опросе.
 *
 * @generated from message yofis.v1.PollOption
 */
export type PollOption = Message$1<"yofis.v1.PollOption"> & {
  /**
   * Текст варианта.
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * Число голосов.
   *
   * @generated from field: int32 votes = 2;
   */
  votes: number;
};

/**
 * Describes the message yofis.v1.PollOption.
 * Use `create(PollOptionSchema)` to create a new message.
 */
export const PollOptionSchema: GenMessage<PollOption> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 3);

/**
 * Элемент форматирования текста.
 *
 * @generated from message yofis.v1.TextEntity
 */
export type TextEntity = Message$1<"yofis.v1.TextEntity"> & {
  /**
   * Тип.
   *
   * @generated from field: yofis.v1.EntityType type = 1;
   */
  type: EntityType;

  /**
   * Смещение начала в кодовых единицах UTF-16.
   *
   * @generated from field: int32 offset = 2;
   */
  offset: number;

  /**
   * Длина в кодовых единицах UTF-16.
   *
   * @generated from field: int32 length = 3;
   */
  length: number;

  /**
   * URL для LINK.
   *
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * Адрес упомянутого пользователя для MENTION.
   *
   * @generated from field: string mention_address = 5;
   */
  mentionAddress: string;
};

/**
 * Describes the message yofis.v1.TextEntity.
 * Use `create(TextEntitySchema)` to create a new message.
 */
export const TextEntitySchema: GenMessage<TextEntity> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 4);

/**
 * Вложение сообщения — ссылка на загруженный файл плюс метаданные для отрисовки без запроса `FileService`.
 *
 * @generated from message yofis.v1.Attachment
 */
export type Attachment = Message$1<"yofis.v1.Attachment"> & {
  /**
   * Идентификатор файла (`FileService`).
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * Вид вложения.
   *
   * @generated from field: yofis.v1.AttachmentKind kind = 2;
   */
  kind: AttachmentKind;

  /**
   * Имя файла.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * MIME-тип.
   *
   * @generated from field: string mime = 4;
   */
  mime: string;

  /**
   * Размер в байтах.
   *
   * @generated from field: int64 size = 5;
   */
  size: bigint;

  /**
   * Ширина в пикселях (IMAGE, VIDEO, VIDEO_NOTE, STICKER).
   *
   * @generated from field: int32 width = 6;
   */
  width: number;

  /**
   * Высота в пикселях.
   *
   * @generated from field: int32 height = 7;
   */
  height: number;

  /**
   * Длительность в миллисекундах (VIDEO, AUDIO, VOICE, VIDEO_NOTE).
   *
   * @generated from field: int32 duration_ms = 8;
   */
  durationMs: number;

  /**
   * Идентификатор файла, по которому доступно превью (`GET /files/<id>/thumb`); обычно совпадает с `file_id`:
   * превью не самостоятельный файл и своей записи не имеет (0.7). Пусто — превью нет.
   *
   * @generated from field: string thumbnail_file_id = 9;
   */
  thumbnailFileId: string;

  /**
   * BlurHash превью для плейсхолдера до загрузки.
   *
   * @generated from field: string blurhash = 10;
   */
  blurhash: string;

  /**
   * VOICE: форма волны — амплитуды 0–100, не более 100 значений.
   *
   * @generated from field: bytes waveform = 11;
   */
  waveform: Uint8Array;
};

/**
 * Describes the message yofis.v1.Attachment.
 * Use `create(AttachmentSchema)` to create a new message.
 */
export const AttachmentSchema: GenMessage<Attachment> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 5);

/**
 * Откуда переслано сообщение.
 *
 * @generated from message yofis.v1.ForwardInfo
 */
export type ForwardInfo = Message$1<"yofis.v1.ForwardInfo"> & {
  /**
   * Исходный чат; пусто, если пересылающий скрыл источник или чат недоступен.
   *
   * @generated from field: string from_chat_id = 1;
   */
  fromChatId: string;

  /**
   * Исходное сообщение.
   *
   * @generated from field: string from_message_id = 2;
   */
  fromMessageId: string;

  /**
   * Автор исходного сообщения.
   *
   * @generated from field: string from_sender_address = 3;
   */
  fromSenderAddress: string;

  /**
   * Когда было отправлено исходное сообщение.
   *
   * @generated from field: google.protobuf.Timestamp original_at = 4;
   */
  originalAt?: Timestamp | undefined;
};

/**
 * Describes the message yofis.v1.ForwardInfo.
 * Use `create(ForwardInfoSchema)` to create a new message.
 */
export const ForwardInfoSchema: GenMessage<ForwardInfo> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 6);

/**
 * Реакция на сообщение (агрегат по эмодзи).
 *
 * @generated from message yofis.v1.Reaction
 */
export type Reaction = Message$1<"yofis.v1.Reaction"> & {
  /**
   * Эмодзи.
   *
   * @generated from field: string emoji = 1;
   */
  emoji: string;

  /**
   * Сколько человек поставили.
   *
   * @generated from field: int32 count = 2;
   */
  count: number;

  /**
   * Поставил ли я.
   *
   * @generated from field: bool mine = 3;
   */
  mine: boolean;
};

/**
 * Describes the message yofis.v1.Reaction.
 * Use `create(ReactionSchema)` to create a new message.
 */
export const ReactionSchema: GenMessage<Reaction> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 7);

/**
 * Системное событие в ленте чата (`Message.kind == SYSTEM`).
 *
 * @generated from message yofis.v1.SystemEvent
 */
export type SystemEvent = Message$1<"yofis.v1.SystemEvent"> & {
  /**
   * Тип события.
   *
   * @generated from field: yofis.v1.SystemEventType type = 1;
   */
  type: SystemEventType;

  /**
   * Кто совершил действие.
   *
   * @generated from field: string actor_address = 2;
   */
  actorAddress: string;

  /**
   * Кого касается (добавленные, удалённые участники).
   *
   * @generated from field: repeated string subject_addresses = 3;
   */
  subjectAddresses: string[];

  /**
   * Значение: новое название, идентификатор закреплённого сообщения, длительность звонка.
   *
   * @generated from field: string value = 4;
   */
  value: string;
};

/**
 * Describes the message yofis.v1.SystemEvent.
 * Use `create(SystemEventSchema)` to create a new message.
 */
export const SystemEventSchema: GenMessage<SystemEvent> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 8);

/**
 * Отправка сообщения.
 *
 * @generated from message yofis.v1.SendMessageRequest
 */
export type SendMessageRequest = Message$1<"yofis.v1.SendMessageRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Клиентский идентификатор (UUIDv7) — идемпотентность и подмена локальной записи.
   *
   * @generated from field: string client_msg_id = 2;
   */
  clientMsgId: string;

  /**
   * Вид сообщения.
   *
   * @generated from field: yofis.v1.MessageKind kind = 3;
   */
  kind: MessageKind;

  /**
   * Текст или подпись.
   *
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * Форматирование.
   *
   * @generated from field: repeated yofis.v1.TextEntity entities = 5;
   */
  entities: TextEntity[];

  /**
   * Файлы-вложения (загружены через `FileService`, состояние READY), в порядке показа.
   *
   * @generated from field: repeated string file_ids = 6;
   */
  fileIds: string[];

  /**
   * На какое сообщение отвечаем; опционально.
   *
   * @generated from field: string reply_to_id = 7;
   */
  replyToId: string;

  /**
   * Пересылка; опционально (для нескольких сообщений — `ForwardMessages`).
   *
   * @generated from field: yofis.v1.ForwardInfo forward = 8;
   */
  forward?: ForwardInfo | undefined;

  /**
   * Геолокация при `kind == LOCATION`.
   *
   * @generated from field: yofis.v1.Location location = 9;
   */
  location?: Location | undefined;

  /**
   * Опрос при `kind == POLL` (`votes`, `total_voters`, `closed`, `my_votes` игнорируются).
   *
   * @generated from field: yofis.v1.Poll poll = 10;
   */
  poll?: Poll | undefined;

  /**
   * Режим шифрования; в v1 только SERVER (или UNSPECIFIED = SERVER).
   *
   * @generated from field: yofis.v1.EncryptionMode encryption_mode = 11;
   */
  encryptionMode: EncryptionMode;

  /**
   * Шифртекст при `encryption_mode == CLIENT` (закладка).
   *
   * @generated from field: bytes client_ciphertext = 12;
   */
  clientCiphertext: Uint8Array;
};

/**
 * Describes the message yofis.v1.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 9);

/**
 * Ответ на отправку.
 *
 * @generated from message yofis.v1.SendMessageResponse
 */
export type SendMessageResponse = Message$1<"yofis.v1.SendMessageResponse"> & {
  /**
   * Сообщение в серверном виде (с `id`, `created_at`).
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message | undefined;
};

/**
 * Describes the message yofis.v1.SendMessageResponse.
 * Use `create(SendMessageResponseSchema)` to create a new message.
 */
export const SendMessageResponseSchema: GenMessage<SendMessageResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 10);

/**
 * Правка сообщения.
 *
 * @generated from message yofis.v1.EditMessageRequest
 */
export type EditMessageRequest = Message$1<"yofis.v1.EditMessageRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * Новый текст.
   *
   * @generated from field: string text = 3;
   */
  text: string;

  /**
   * Новое форматирование.
   *
   * @generated from field: repeated yofis.v1.TextEntity entities = 4;
   */
  entities: TextEntity[];
};

/**
 * Describes the message yofis.v1.EditMessageRequest.
 * Use `create(EditMessageRequestSchema)` to create a new message.
 */
export const EditMessageRequestSchema: GenMessage<EditMessageRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 11);

/**
 * Ответ на правку.
 *
 * @generated from message yofis.v1.EditMessageResponse
 */
export type EditMessageResponse = Message$1<"yofis.v1.EditMessageResponse"> & {
  /**
   * Сообщение после правки.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message | undefined;
};

/**
 * Describes the message yofis.v1.EditMessageResponse.
 * Use `create(EditMessageResponseSchema)` to create a new message.
 */
export const EditMessageResponseSchema: GenMessage<EditMessageResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 12);

/**
 * Удаление сообщения.
 *
 * @generated from message yofis.v1.DeleteMessageRequest
 */
export type DeleteMessageRequest = Message$1<"yofis.v1.DeleteMessageRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * Удалить у всех участников; false — только скрыть у себя.
   *
   * @generated from field: bool for_everyone = 3;
   */
  forEveryone: boolean;
};

/**
 * Describes the message yofis.v1.DeleteMessageRequest.
 * Use `create(DeleteMessageRequestSchema)` to create a new message.
 */
export const DeleteMessageRequestSchema: GenMessage<DeleteMessageRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 13);

/**
 * Ответ на удаление; полей нет.
 *
 * @generated from message yofis.v1.DeleteMessageResponse
 */
export type DeleteMessageResponse = Message$1<"yofis.v1.DeleteMessageResponse"> & {
};

/**
 * Describes the message yofis.v1.DeleteMessageResponse.
 * Use `create(DeleteMessageResponseSchema)` to create a new message.
 */
export const DeleteMessageResponseSchema: GenMessage<DeleteMessageResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 14);

/**
 * Якорь выборки истории. Не задан якорь (или пустой oneof) — последние сообщения чата.
 *
 * @generated from message yofis.v1.MessageAnchor
 */
export type MessageAnchor = Message$1<"yofis.v1.MessageAnchor"> & {
  /**
   * Ровно одно из.
   *
   * @generated from oneof yofis.v1.MessageAnchor.anchor
   */
  anchor: {
    /**
     * Сообщения старше указанного (не включая его).
     *
     * @generated from field: string before_id = 1;
     */
    value: string;
    case: "beforeId";
  } | {
    /**
     * Сообщения новее указанного (не включая его).
     *
     * @generated from field: string after_id = 2;
     */
    value: string;
    case: "afterId";
  } | {
    /**
     * Сообщения вокруг указанного (включая его): половина лимита до, половина после.
     *
     * @generated from field: string around_id = 3;
     */
    value: string;
    case: "aroundId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yofis.v1.MessageAnchor.
 * Use `create(MessageAnchorSchema)` to create a new message.
 */
export const MessageAnchorSchema: GenMessage<MessageAnchor> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 15);

/**
 * Запрос истории.
 *
 * @generated from message yofis.v1.GetMessagesRequest
 */
export type GetMessagesRequest = Message$1<"yofis.v1.GetMessagesRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Якорь; пусто — последние сообщения.
   *
   * @generated from field: yofis.v1.MessageAnchor anchor = 2;
   */
  anchor?: MessageAnchor | undefined;

  /**
   * Сколько сообщений; по умолчанию 50, максимум 200.
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message yofis.v1.GetMessagesRequest.
 * Use `create(GetMessagesRequestSchema)` to create a new message.
 */
export const GetMessagesRequestSchema: GenMessage<GetMessagesRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 16);

/**
 * Ответ с историей.
 *
 * @generated from message yofis.v1.GetMessagesResponse
 */
export type GetMessagesResponse = Message$1<"yofis.v1.GetMessagesResponse"> & {
  /**
   * Сообщения по возрастанию `id`.
   *
   * @generated from field: repeated yofis.v1.Message messages = 1;
   */
  messages: Message[];

  /**
   * Есть ли сообщения старше первого в ответе.
   *
   * @generated from field: bool has_more_before = 2;
   */
  hasMoreBefore: boolean;

  /**
   * Есть ли сообщения новее последнего в ответе.
   *
   * @generated from field: bool has_more_after = 3;
   */
  hasMoreAfter: boolean;
};

/**
 * Describes the message yofis.v1.GetMessagesResponse.
 * Use `create(GetMessagesResponseSchema)` to create a new message.
 */
export const GetMessagesResponseSchema: GenMessage<GetMessagesResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 17);

/**
 * Запрос одного сообщения.
 *
 * @generated from message yofis.v1.GetMessageRequest
 */
export type GetMessageRequest = Message$1<"yofis.v1.GetMessageRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;
};

/**
 * Describes the message yofis.v1.GetMessageRequest.
 * Use `create(GetMessageRequestSchema)` to create a new message.
 */
export const GetMessageRequestSchema: GenMessage<GetMessageRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 18);

/**
 * Ответ с сообщением.
 *
 * @generated from message yofis.v1.GetMessageResponse
 */
export type GetMessageResponse = Message$1<"yofis.v1.GetMessageResponse"> & {
  /**
   * Сообщение.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message | undefined;
};

/**
 * Describes the message yofis.v1.GetMessageResponse.
 * Use `create(GetMessageResponseSchema)` to create a new message.
 */
export const GetMessageResponseSchema: GenMessage<GetMessageResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 19);

/**
 * Поиск сообщений.
 *
 * @generated from message yofis.v1.SearchMessagesRequest
 */
export type SearchMessagesRequest = Message$1<"yofis.v1.SearchMessagesRequest"> & {
  /**
   * Строка поиска.
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * Ограничить одним чатом; пусто — по всем моим чатам.
   *
   * @generated from field: string chat_id = 2;
   */
  chatId: string;

  /**
   * Курсор страницы.
   *
   * @generated from field: string cursor = 3;
   */
  cursor: string;

  /**
   * Размер страницы; по умолчанию 50, максимум 200.
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message yofis.v1.SearchMessagesRequest.
 * Use `create(SearchMessagesRequestSchema)` to create a new message.
 */
export const SearchMessagesRequestSchema: GenMessage<SearchMessagesRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 20);

/**
 * Ответ с результатами поиска.
 *
 * @generated from message yofis.v1.SearchMessagesResponse
 */
export type SearchMessagesResponse = Message$1<"yofis.v1.SearchMessagesResponse"> & {
  /**
   * Совпадения, от новых к старым.
   *
   * @generated from field: repeated yofis.v1.MessageSearchHit hits = 1;
   */
  hits: MessageSearchHit[];

  /**
   * Пагинация.
   *
   * @generated from field: yofis.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message yofis.v1.SearchMessagesResponse.
 * Use `create(SearchMessagesResponseSchema)` to create a new message.
 */
export const SearchMessagesResponseSchema: GenMessage<SearchMessagesResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 21);

/**
 * Совпадение при поиске.
 *
 * @generated from message yofis.v1.MessageSearchHit
 */
export type MessageSearchHit = Message$1<"yofis.v1.MessageSearchHit"> & {
  /**
   * Сообщение.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message | undefined;

  /**
   * Фрагмент текста вокруг совпадения для списка результатов.
   *
   * @generated from field: string snippet = 2;
   */
  snippet: string;
};

/**
 * Describes the message yofis.v1.MessageSearchHit.
 * Use `create(MessageSearchHitSchema)` to create a new message.
 */
export const MessageSearchHitSchema: GenMessage<MessageSearchHit> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 22);

/**
 * Установка или снятие реакции.
 *
 * @generated from message yofis.v1.SetReactionRequest
 */
export type SetReactionRequest = Message$1<"yofis.v1.SetReactionRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * Эмодзи.
   *
   * @generated from field: string emoji = 3;
   */
  emoji: string;

  /**
   * true — поставить, false — снять.
   *
   * @generated from field: bool set = 4;
   */
  set: boolean;
};

/**
 * Describes the message yofis.v1.SetReactionRequest.
 * Use `create(SetReactionRequestSchema)` to create a new message.
 */
export const SetReactionRequestSchema: GenMessage<SetReactionRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 23);

/**
 * Ответ на реакцию.
 *
 * @generated from message yofis.v1.SetReactionResponse
 */
export type SetReactionResponse = Message$1<"yofis.v1.SetReactionResponse"> & {
  /**
   * Сообщение с обновлёнными реакциями.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message | undefined;
};

/**
 * Describes the message yofis.v1.SetReactionResponse.
 * Use `create(SetReactionResponseSchema)` to create a new message.
 */
export const SetReactionResponseSchema: GenMessage<SetReactionResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 24);

/**
 * Пересылка сообщений.
 *
 * @generated from message yofis.v1.ForwardMessagesRequest
 */
export type ForwardMessagesRequest = Message$1<"yofis.v1.ForwardMessagesRequest"> & {
  /**
   * Откуда.
   *
   * @generated from field: string from_chat_id = 1;
   */
  fromChatId: string;

  /**
   * Какие сообщения, в порядке пересылки.
   *
   * @generated from field: repeated string message_ids = 2;
   */
  messageIds: string[];

  /**
   * Куда.
   *
   * @generated from field: string to_chat_id = 3;
   */
  toChatId: string;

  /**
   * Клиентские идентификаторы новых сообщений — по одному на каждое из `message_ids`.
   *
   * @generated from field: repeated string client_msg_ids = 4;
   */
  clientMsgIds: string[];
};

/**
 * Describes the message yofis.v1.ForwardMessagesRequest.
 * Use `create(ForwardMessagesRequestSchema)` to create a new message.
 */
export const ForwardMessagesRequestSchema: GenMessage<ForwardMessagesRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 25);

/**
 * Ответ на пересылку.
 *
 * @generated from message yofis.v1.ForwardMessagesResponse
 */
export type ForwardMessagesResponse = Message$1<"yofis.v1.ForwardMessagesResponse"> & {
  /**
   * Созданные сообщения в порядке `message_ids`.
   *
   * @generated from field: repeated yofis.v1.Message messages = 1;
   */
  messages: Message[];
};

/**
 * Describes the message yofis.v1.ForwardMessagesResponse.
 * Use `create(ForwardMessagesResponseSchema)` to create a new message.
 */
export const ForwardMessagesResponseSchema: GenMessage<ForwardMessagesResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 26);

/**
 * Закрепление сообщения.
 *
 * @generated from message yofis.v1.PinMessageRequest
 */
export type PinMessageRequest = Message$1<"yofis.v1.PinMessageRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;
};

/**
 * Describes the message yofis.v1.PinMessageRequest.
 * Use `create(PinMessageRequestSchema)` to create a new message.
 */
export const PinMessageRequestSchema: GenMessage<PinMessageRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 27);

/**
 * Ответ на закрепление; полей нет.
 *
 * @generated from message yofis.v1.PinMessageResponse
 */
export type PinMessageResponse = Message$1<"yofis.v1.PinMessageResponse"> & {
};

/**
 * Describes the message yofis.v1.PinMessageResponse.
 * Use `create(PinMessageResponseSchema)` to create a new message.
 */
export const PinMessageResponseSchema: GenMessage<PinMessageResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 28);

/**
 * Открепление сообщения.
 *
 * @generated from message yofis.v1.UnpinMessageRequest
 */
export type UnpinMessageRequest = Message$1<"yofis.v1.UnpinMessageRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;
};

/**
 * Describes the message yofis.v1.UnpinMessageRequest.
 * Use `create(UnpinMessageRequestSchema)` to create a new message.
 */
export const UnpinMessageRequestSchema: GenMessage<UnpinMessageRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 29);

/**
 * Ответ на открепление; полей нет.
 *
 * @generated from message yofis.v1.UnpinMessageResponse
 */
export type UnpinMessageResponse = Message$1<"yofis.v1.UnpinMessageResponse"> & {
};

/**
 * Describes the message yofis.v1.UnpinMessageResponse.
 * Use `create(UnpinMessageResponseSchema)` to create a new message.
 */
export const UnpinMessageResponseSchema: GenMessage<UnpinMessageResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 30);

/**
 * Запрос закреплённых сообщений.
 *
 * @generated from message yofis.v1.ListPinnedMessagesRequest
 */
export type ListPinnedMessagesRequest = Message$1<"yofis.v1.ListPinnedMessagesRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;
};

/**
 * Describes the message yofis.v1.ListPinnedMessagesRequest.
 * Use `create(ListPinnedMessagesRequestSchema)` to create a new message.
 */
export const ListPinnedMessagesRequestSchema: GenMessage<ListPinnedMessagesRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 31);

/**
 * Ответ с закреплёнными сообщениями.
 *
 * @generated from message yofis.v1.ListPinnedMessagesResponse
 */
export type ListPinnedMessagesResponse = Message$1<"yofis.v1.ListPinnedMessagesResponse"> & {
  /**
   * Закреплённые сообщения, от новых к старым.
   *
   * @generated from field: repeated yofis.v1.Message messages = 1;
   */
  messages: Message[];
};

/**
 * Describes the message yofis.v1.ListPinnedMessagesResponse.
 * Use `create(ListPinnedMessagesResponseSchema)` to create a new message.
 */
export const ListPinnedMessagesResponseSchema: GenMessage<ListPinnedMessagesResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 32);

/**
 * Голосование в опросе.
 *
 * @generated from message yofis.v1.VotePollRequest
 */
export type VotePollRequest = Message$1<"yofis.v1.VotePollRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение с опросом.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * Индексы выбранных вариантов; несколько — только при `multiple_choice`; пусто — отозвать голос.
   *
   * @generated from field: repeated int32 option_indexes = 3;
   */
  optionIndexes: number[];
};

/**
 * Describes the message yofis.v1.VotePollRequest.
 * Use `create(VotePollRequestSchema)` to create a new message.
 */
export const VotePollRequestSchema: GenMessage<VotePollRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 33);

/**
 * Ответ на голосование.
 *
 * @generated from message yofis.v1.VotePollResponse
 */
export type VotePollResponse = Message$1<"yofis.v1.VotePollResponse"> & {
  /**
   * Сообщение с обновлённым опросом.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message | undefined;
};

/**
 * Describes the message yofis.v1.VotePollResponse.
 * Use `create(VotePollResponseSchema)` to create a new message.
 */
export const VotePollResponseSchema: GenMessage<VotePollResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 34);

/**
 * Закрытие опроса.
 *
 * @generated from message yofis.v1.ClosePollRequest
 */
export type ClosePollRequest = Message$1<"yofis.v1.ClosePollRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение с опросом.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;
};

/**
 * Describes the message yofis.v1.ClosePollRequest.
 * Use `create(ClosePollRequestSchema)` to create a new message.
 */
export const ClosePollRequestSchema: GenMessage<ClosePollRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 35);

/**
 * Ответ на закрытие опроса.
 *
 * @generated from message yofis.v1.ClosePollResponse
 */
export type ClosePollResponse = Message$1<"yofis.v1.ClosePollResponse"> & {
  /**
   * Сообщение с закрытым опросом.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message | undefined;
};

/**
 * Describes the message yofis.v1.ClosePollResponse.
 * Use `create(ClosePollResponseSchema)` to create a new message.
 */
export const ClosePollResponseSchema: GenMessage<ClosePollResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 36);

/**
 * Обновление live-геолокации.
 *
 * @generated from message yofis.v1.UpdateLiveLocationRequest
 */
export type UpdateLiveLocationRequest = Message$1<"yofis.v1.UpdateLiveLocationRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение с live-геолокацией.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * Широта.
   *
   * @generated from field: double lat = 3;
   */
  lat: number;

  /**
   * Долгота.
   *
   * @generated from field: double lon = 4;
   */
  lon: number;

  /**
   * Точность в метрах.
   *
   * @generated from field: float accuracy_m = 5;
   */
  accuracyM: number;
};

/**
 * Describes the message yofis.v1.UpdateLiveLocationRequest.
 * Use `create(UpdateLiveLocationRequestSchema)` to create a new message.
 */
export const UpdateLiveLocationRequestSchema: GenMessage<UpdateLiveLocationRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 37);

/**
 * Ответ на обновление live-геолокации; полей нет.
 *
 * @generated from message yofis.v1.UpdateLiveLocationResponse
 */
export type UpdateLiveLocationResponse = Message$1<"yofis.v1.UpdateLiveLocationResponse"> & {
};

/**
 * Describes the message yofis.v1.UpdateLiveLocationResponse.
 * Use `create(UpdateLiveLocationResponseSchema)` to create a new message.
 */
export const UpdateLiveLocationResponseSchema: GenMessage<UpdateLiveLocationResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 38);

/**
 * Остановка live-геолокации.
 *
 * @generated from message yofis.v1.StopLiveLocationRequest
 */
export type StopLiveLocationRequest = Message$1<"yofis.v1.StopLiveLocationRequest"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение с live-геолокацией.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;
};

/**
 * Describes the message yofis.v1.StopLiveLocationRequest.
 * Use `create(StopLiveLocationRequestSchema)` to create a new message.
 */
export const StopLiveLocationRequestSchema: GenMessage<StopLiveLocationRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 39);

/**
 * Ответ на остановку live-геолокации.
 *
 * @generated from message yofis.v1.StopLiveLocationResponse
 */
export type StopLiveLocationResponse = Message$1<"yofis.v1.StopLiveLocationResponse"> & {
  /**
   * Сообщение; `location.live_until` установлен в момент остановки.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message | undefined;
};

/**
 * Describes the message yofis.v1.StopLiveLocationResponse.
 * Use `create(StopLiveLocationResponseSchema)` to create a new message.
 */
export const StopLiveLocationResponseSchema: GenMessage<StopLiveLocationResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_message, 40);

/**
 * Вид сообщения.
 *
 * @generated from enum yofis.v1.MessageKind
 */
export enum MessageKind {
  /**
   * Не задан.
   *
   * @generated from enum value: MESSAGE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Текст.
   *
   * @generated from enum value: MESSAGE_KIND_TEXT = 1;
   */
  TEXT = 1,

  /**
   * Медиа (фото, видео, голосовое, кружочек) с подписью.
   *
   * @generated from enum value: MESSAGE_KIND_MEDIA = 2;
   */
  MEDIA = 2,

  /**
   * Файлы с подписью.
   *
   * @generated from enum value: MESSAGE_KIND_FILE = 3;
   */
  FILE = 3,

  /**
   * Системное сообщение (`Message.system`).
   *
   * @generated from enum value: MESSAGE_KIND_SYSTEM = 4;
   */
  SYSTEM = 4,

  /**
   * Геолокация (`Message.location`): разовая точка (v1) или live (v2).
   *
   * @generated from enum value: MESSAGE_KIND_LOCATION = 5;
   */
  LOCATION = 5,

  /**
   * Опрос (`Message.poll`).
   *
   * @generated from enum value: MESSAGE_KIND_POLL = 6;
   */
  POLL = 6,
}

/**
 * Describes the enum yofis.v1.MessageKind.
 */
export const MessageKindSchema: GenEnum<MessageKind> = /*@__PURE__*/
  enumDesc(file_yofis_v1_message, 0);

/**
 * Тип элемента форматирования.
 *
 * @generated from enum yofis.v1.EntityType
 */
export enum EntityType {
  /**
   * Не задан.
   *
   * @generated from enum value: ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Жирный.
   *
   * @generated from enum value: ENTITY_TYPE_BOLD = 1;
   */
  BOLD = 1,

  /**
   * Курсив.
   *
   * @generated from enum value: ENTITY_TYPE_ITALIC = 2;
   */
  ITALIC = 2,

  /**
   * Подчёркнутый.
   *
   * @generated from enum value: ENTITY_TYPE_UNDERLINE = 3;
   */
  UNDERLINE = 3,

  /**
   * Зачёркнутый.
   *
   * @generated from enum value: ENTITY_TYPE_STRIKETHROUGH = 4;
   */
  STRIKETHROUGH = 4,

  /**
   * Код в строке.
   *
   * @generated from enum value: ENTITY_TYPE_CODE = 5;
   */
  CODE = 5,

  /**
   * Блок кода.
   *
   * @generated from enum value: ENTITY_TYPE_PRE = 6;
   */
  PRE = 6,

  /**
   * Ссылка (`url`).
   *
   * @generated from enum value: ENTITY_TYPE_LINK = 7;
   */
  LINK = 7,

  /**
   * Упоминание пользователя (`mention_address`).
   *
   * @generated from enum value: ENTITY_TYPE_MENTION = 8;
   */
  MENTION = 8,

  /**
   * Спойлер (скрыто до нажатия).
   *
   * @generated from enum value: ENTITY_TYPE_SPOILER = 9;
   */
  SPOILER = 9,
}

/**
 * Describes the enum yofis.v1.EntityType.
 */
export const EntityTypeSchema: GenEnum<EntityType> = /*@__PURE__*/
  enumDesc(file_yofis_v1_message, 1);

/**
 * Вид вложения.
 *
 * @generated from enum yofis.v1.AttachmentKind
 */
export enum AttachmentKind {
  /**
   * Не задан.
   *
   * @generated from enum value: ATTACHMENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Изображение.
   *
   * @generated from enum value: ATTACHMENT_KIND_IMAGE = 1;
   */
  IMAGE = 1,

  /**
   * Видео.
   *
   * @generated from enum value: ATTACHMENT_KIND_VIDEO = 2;
   */
  VIDEO = 2,

  /**
   * Аудиофайл (музыка, запись).
   *
   * @generated from enum value: ATTACHMENT_KIND_AUDIO = 3;
   */
  AUDIO = 3,

  /**
   * Голосовое сообщение (opus/aac; `waveform`).
   *
   * @generated from enum value: ATTACHMENT_KIND_VOICE = 4;
   */
  VOICE = 4,

  /**
   * Произвольный файл.
   *
   * @generated from enum value: ATTACHMENT_KIND_FILE = 5;
   */
  FILE = 5,

  /**
   * «Кружочек»: квадратное видео ≤ 60 с, показывается круглым (v1.5).
   *
   * @generated from enum value: ATTACHMENT_KIND_VIDEO_NOTE = 6;
   */
  VIDEO_NOTE = 6,

  /**
   * Стикер — закладка (v3).
   *
   * @generated from enum value: ATTACHMENT_KIND_STICKER = 7;
   */
  STICKER = 7,
}

/**
 * Describes the enum yofis.v1.AttachmentKind.
 */
export const AttachmentKindSchema: GenEnum<AttachmentKind> = /*@__PURE__*/
  enumDesc(file_yofis_v1_message, 2);

/**
 * Тип системного события.
 *
 * @generated from enum yofis.v1.SystemEventType
 */
export enum SystemEventType {
  /**
   * Не задан.
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Участник вошёл (по ссылке).
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_MEMBER_JOINED = 1;
   */
  MEMBER_JOINED = 1,

  /**
   * Участник вышел.
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_MEMBER_LEFT = 2;
   */
  MEMBER_LEFT = 2,

  /**
   * Участника добавили (`subject_addresses`).
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_MEMBER_ADDED = 3;
   */
  MEMBER_ADDED = 3,

  /**
   * Участника удалили.
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_MEMBER_REMOVED = 4;
   */
  MEMBER_REMOVED = 4,

  /**
   * Изменено название (`value` — новое).
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_TITLE_CHANGED = 5;
   */
  TITLE_CHANGED = 5,

  /**
   * Изменён аватар.
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_AVATAR_CHANGED = 6;
   */
  AVATAR_CHANGED = 6,

  /**
   * Чат создан.
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_CHAT_CREATED = 7;
   */
  CHAT_CREATED = 7,

  /**
   * Сообщение закреплено (`value` — его идентификатор).
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_PINNED = 8;
   */
  PINNED = 8,

  /**
   * Начался звонок.
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_CALL_STARTED = 9;
   */
  CALL_STARTED = 9,

  /**
   * Звонок завершён (`value` — длительность в секундах).
   *
   * @generated from enum value: SYSTEM_EVENT_TYPE_CALL_ENDED = 10;
   */
  CALL_ENDED = 10,
}

/**
 * Describes the enum yofis.v1.SystemEventType.
 */
export const SystemEventTypeSchema: GenEnum<SystemEventType> = /*@__PURE__*/
  enumDesc(file_yofis_v1_message, 3);

/**
 * Отправка, чтение и правка сообщений. Уровень всех методов — signed.
 *
 * @generated from service yofis.v1.MessageService
 */
export const MessageService: GenService<{
  /**
   * Отправить сообщение. Повтор с тем же `client_msg_id` возвращает то же сообщение (идемпотентно).
   * `encryption_mode` в v1 — только SERVER; `location`/`poll` — по `kind`.
   * Уровень: signed. Ошибки: NOT_MEMBER, POSTING_RESTRICTED, MESSAGE_TOO_LONG, TOO_MANY_ATTACHMENTS,
   * BLOCKED_BY_PEER, IDEMPOTENCY_CONFLICT, CAPABILITY_DISABLED.
   *
   * @generated from rpc yofis.v1.MessageService.SendMessage
   */
  sendMessage: {
    methodKind: "unary";
    input: typeof SendMessageRequestSchema;
    output: typeof SendMessageResponseSchema;
  },
  /**
   * Изменить текст своего сообщения. Окно редактирования — `NodeSettings.message_edit_window_hours` (по умолчанию 48 ч).
   * Уровень: signed. Ошибки: permission_denied (чужое), failed_precondition (окно истекло).
   *
   * @generated from rpc yofis.v1.MessageService.EditMessage
   */
  editMessage: {
    methodKind: "unary";
    input: typeof EditMessageRequestSchema;
    output: typeof EditMessageResponseSchema;
  },
  /**
   * Удалить сообщение: у себя или у всех (`for_everyone`; своё — всегда, чужое — ADMIN/OWNER чата).
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.DeleteMessage
   */
  deleteMessage: {
    methodKind: "unary";
    input: typeof DeleteMessageRequestSchema;
    output: typeof DeleteMessageResponseSchema;
  },
  /**
   * История чата относительно якоря; ответ всегда по возрастанию `id`.
   * Уровень: signed. Ошибки: NOT_MEMBER.
   *
   * @generated from rpc yofis.v1.MessageService.GetMessages
   */
  getMessages: {
    methodKind: "unary";
    input: typeof GetMessagesRequestSchema;
    output: typeof GetMessagesResponseSchema;
  },
  /**
   * Одно сообщение.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.GetMessage
   */
  getMessage: {
    methodKind: "unary";
    input: typeof GetMessageRequestSchema;
    output: typeof GetMessageResponseSchema;
  },
  /**
   * Полнотекстовый поиск по моим чатам или по одному чату.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.SearchMessages
   */
  searchMessages: {
    methodKind: "unary";
    input: typeof SearchMessagesRequestSchema;
    output: typeof SearchMessagesResponseSchema;
  },
  /**
   * Поставить или снять реакцию.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.SetReaction
   */
  setReaction: {
    methodKind: "unary";
    input: typeof SetReactionRequestSchema;
    output: typeof SetReactionResponseSchema;
  },
  /**
   * Переслать сообщения в другой чат; на каждое — свой `client_msg_id`.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.ForwardMessages
   */
  forwardMessages: {
    methodKind: "unary";
    input: typeof ForwardMessagesRequestSchema;
    output: typeof ForwardMessagesResponseSchema;
  },
  /**
   * Закрепить сообщение в чате (права по `ChatSettings.only_admins_edit_info`).
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.PinMessage
   */
  pinMessage: {
    methodKind: "unary";
    input: typeof PinMessageRequestSchema;
    output: typeof PinMessageResponseSchema;
  },
  /**
   * Открепить сообщение.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.UnpinMessage
   */
  unpinMessage: {
    methodKind: "unary";
    input: typeof UnpinMessageRequestSchema;
    output: typeof UnpinMessageResponseSchema;
  },
  /**
   * Закреплённые сообщения чата, от новых к старым.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.ListPinnedMessages
   */
  listPinnedMessages: {
    methodKind: "unary";
    input: typeof ListPinnedMessagesRequestSchema;
    output: typeof ListPinnedMessagesResponseSchema;
  },
  /**
   * Проголосовать в опросе; повторный вызов меняет голос. После `closes_at`/`closed` — failed_precondition.
   * Уровень: signed. Ошибки: CAPABILITY_DISABLED.
   *
   * @generated from rpc yofis.v1.MessageService.VotePoll
   */
  votePoll: {
    methodKind: "unary";
    input: typeof VotePollRequestSchema;
    output: typeof VotePollResponseSchema;
  },
  /**
   * Закрыть опрос досрочно: автор или ADMIN чата.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.ClosePoll
   */
  closePoll: {
    methodKind: "unary";
    input: typeof ClosePollRequestSchema;
    output: typeof ClosePollResponseSchema;
  },
  /**
   * Обновить live-геолокацию: только отправитель, пока `live_until` не истёк; не чаще раза в 5 с.
   * Рассылается участникам как `MessageEdited`.
   * Уровень: signed. Ошибки: RATE_LIMITED, failed_precondition (истекло), CAPABILITY_DISABLED.
   *
   * @generated from rpc yofis.v1.MessageService.UpdateLiveLocation
   */
  updateLiveLocation: {
    methodKind: "unary";
    input: typeof UpdateLiveLocationRequestSchema;
    output: typeof UpdateLiveLocationResponseSchema;
  },
  /**
   * Остановить трансляцию live-геолокации досрочно.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.MessageService.StopLiveLocation
   */
  stopLiveLocation: {
    methodKind: "unary";
    input: typeof StopLiveLocationRequestSchema;
    output: typeof StopLiveLocationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yofis_v1_message, 0);

